import * as React from "react";
import Collapsible from "react-collapsible";
import RequisitionDetails from "./RequisitionDetails";
import PositionDetails from "./PositionDetails";
import ApprovalsWFGrid from "../../Shared/ApprovalsWFGrid/ApprovalsWFGrid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { REQ_APPROVERS_WARNING_MSG, SAVED_ORDER_SUCCESS_MSG, SUBMIT_ORDER_SUCCESS_MSG, TS_APPROVERS_REQUIRED_WARNING_MSG, TS_APPROVERS_WARNING_MSG, REQ_SHIFT_RESET_CONFIRM_MSG } from "../../Shared/AppMessages";
import { faCheckCircle, faChevronCircleDown, faChevronCircleUp, faSave, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import auth from "../../Auth";
import { ICreateRequisitionState, ICreateRequisitionProps } from "./models/ICreateRequisitionState";
import axios from "axios";
import { history, successToastr, errorToastr, infoToastr, warningToastr, toLocalDateTime, clientSettingsData, applySettingFilters, getClientSettingsData } from "../../../HelperMethods";
import { Form, Formik } from "formik";
import { requisitionValidation, validate } from "./validations/validation";
import { Prompt } from "react-router";
import { Link } from "react-router-dom";
import "../../../assets/css/App.css";
import "./CreateRequisition.css";
import { FormatPhoneNumber } from "../../ReusableComponents";
import ErrorFocus from "../../Shared/ErrorFocus";
import _, { includes } from "lodash";
import { APP_HOME_URL } from "../../Shared/ApiUrls";
import { AppPermissions } from "../../Shared/Constants/AppPermissions";
import { EntityType, ReqStatus, SETTINGS, SettingCategory } from "../../Shared/AppConstants";
import BreadCrumbs from "../../Shared/BreadCrumbs/BreadCrumbs";
import ManageShifts from "./Shifts/ManageShifts";
import ConfirmationModal from "../../Shared/ConfirmationModal";

//const billRate = 100;

class CreateRequisition extends React.Component<ICreateRequisitionProps, ICreateRequisitionState> {
    public reqChild: any;
    public positionChild: any;
    public ManageShiftsChild: any;
    public reqApprovalChild: any;
    public tsApprovalChild: any;
    //   public { id } = this.props.match.params;
    initialState = {
        reqId: this.props.match.params.id ? this.props.match.params.id : "",
        reqNumber: "",
        clientId: auth.getClient(),
        clientDivisionId: "",
        divisionLocationId: "",
        divLocId: "",
        purchaseOrder: "",
        clientContactNum: "",
        divisionContactId: "",
        reasonId: "",
        customerLocation: "",
        justification: "",
        status: "",
        reqPosition: {
            jobWf: { id: null, name: "Select" },
            jobCategory: { id: null, name: "Select" },
            jobPosition: { id: null, name: "Select" },
            hiringManager: { id: null, name: "Select" },
            assignType: { id: null, name: "Select" },
            startDate: new Date(),
            //endDate: new Date(new Date().setDate(new Date().getDate() + 1)),
            endDate: null,
            shiftStartTime: new Date(new Date(new Date().setHours(9)).setMinutes(0)),
            shiftEndTime: new Date(new Date(new Date().setHours(17)).setMinutes(30)),
            positionSkillMapping: [],
            //billRate: billRate,
            positionDesc: "",
            noOfReqStaff: 1,
        },
        reqApproverDetails: {},
        timesheetApproverDetails: {},
        toggleAll: false,
        isDirty: false,
        toggelFirst: true,
        toggleFourth: false,
        toggleThird: false,
        toggleSecond: false,
        toggleFifth: false,
        submitted: false,
        errorValidate: true,
        allowEdit: false,
        departmentId: "",
        isPilot: false,
        showTargetRate: true,
        displayClientAtsReq: false,
        shiftScheduling: false,
        atsReqNumber: "",
        showShiftResetConfirmation: false,
        pendingShiftReset: false,
        pendingChanges: null,
        displaySalesforceContractNumber: false,
        salesforceContractNumber: "",
        displayEntityNumber: false,
        entityNumber:""
    };

    constructor(props: ICreateRequisitionProps) {

        super(props);

        this.state = this.initialState;
        window.onbeforeunload = this.hasUsavedData.bind(this);
    }

    componentDidMount() {
        const { reqId } = this.state;
        if (reqId) {
            this.getReqDetails(reqId);
        }
        else {
            this.setState({ status: ReqStatus.DRAFT });
        }

        if (auth.hasPermissionV2(AppPermissions.REQ_CREATE)) {
            this.setState({ allowEdit: true })
        }
        this.getClientSetting(this.state.clientId);
        this.getServiceCategories();
    }

    componentDidUpdate(nextProps) {
        if (this.props.location.key != nextProps.location.key) {
            this.setState(this.initialState)
            const { reqId } = this.state;
            if (reqId) {
                this.getReqDetails(reqId);
            }
            else {
                this.setState({ status: ReqStatus.DRAFT });
            }
        }
    }
    componentWillUnmount() {
        window.onbeforeunload = null;
    }

    handleChange = (e) => {
        let change = { isDirty: true };
        change[e.target.name] = e.target.value;

        this.setState(change);
    };

    handleChangePurchaseOrder = (value) => {
        this.setState({ purchaseOrder: value });
    }

    handleObjChange = (change) => {
        var changeCopy = { ...change };
        if (change.hasOwnProperty("reqPosition")) {
            const { reqPosition } = this.state;
            change.reqPosition = { ...reqPosition, ...change.reqPosition };
        }
        if (change.hasOwnProperty("reqPosition") && change.reqPosition && !change.reqPosition.reqPositionId) {
            change["isDirty"] = true;
        }

        // Check if location, department, or position has changed for ShiftCreation
        const shouldReloadShifts =
            (change.divisionLocationId && change.divisionLocationId !== this.state.divisionLocationId) ||
            (change.departmentId && change.departmentId !== this.state.departmentId) ||
            (change.reqPosition && change.reqPosition.jobPosition &&
                change.reqPosition.jobPosition.id !== this.state.reqPosition.jobPosition.id);

        // If we have a valid reqId and existing shifts, show confirmation dialog
        if (shouldReloadShifts && this.state.reqId && this.ManageShiftsChild && this.ManageShiftsChild.getAllShifts().length > 0) {
            // Store the pending changes and show confirmation dialog
            this.setState({ 
                showShiftResetConfirmation: true, 
                pendingShiftReset: true,
                pendingChanges: change // Store the pending changes
            });
            return;
        }

        // If no confirmation needed, just update the state
        this.setState(change, () => {
            this.getApprovers(changeCopy, EntityType.REQUISITION);
            this.getApprovers(changeCopy, EntityType.TIMESHEET);
            // If any of the key fields changed and we have all required fields, reload ShiftCreation
            if (shouldReloadShifts &&
                this.state.divisionLocationId &&
                this.state.departmentId &&
                this.state.reqPosition.jobPosition?.id) {

                // Reset and reload shifts in ShiftCreation component
                if (this.ManageShiftsChild && typeof this.ManageShiftsChild.reloadDefaultShifts === 'function') {
                    this.ManageShiftsChild.reloadDefaultShifts();
                }
            }

        });
    };

    getApprovers(change, entityType) {
        // req status draft and when approvers are not generated against entity
        if (this.state.status == ReqStatus.DRAFT && ((entityType == EntityType.REQUISITION && !this.state.reqApproverDetails.entityId) || (entityType == EntityType.TIMESHEET && !this.state.timesheetApproverDetails.entityId)))
            if (change.hasOwnProperty('clientDivisionId') || change.hasOwnProperty('divisionLocationId') ||
                (change.hasOwnProperty('reqPosition') && change.reqPosition.jobPosition && !change.reqPosition.startDate)) {
                const { clientId, clientDivisionId, divisionLocationId, reqPosition } = this.state;
                if (clientId && clientDivisionId && divisionLocationId && reqPosition.jobPosition && reqPosition.jobPosition.id) {
                    if (entityType == EntityType.REQUISITION) {
                        this.reqApprovalChild.getApproverDetailsByClient(clientId, EntityType.REQUISITION,
                            clientDivisionId, divisionLocationId, reqPosition.jobPosition.id);
                    }
                    if (entityType == EntityType.TIMESHEET) {
                        this.tsApprovalChild.getApproverDetailsByClient(clientId, EntityType.TIMESHEET,
                            clientDivisionId, divisionLocationId, reqPosition.jobPosition.id);
                    }
                }
            }
    }

    handleDropdownChange = (e) => {
        let change = { isDirty: true };
        change[e.target.props.name] = e.target.value;

        // Check if department has changed for ShiftCreation
        const shouldReloadShifts = e.target.props.name === "departmentId" && 
            e.target.value !== this.state.departmentId;

        // If we have a valid reqId and existing shifts, show confirmation dialog
        if (shouldReloadShifts && this.state.reqId && this.ManageShiftsChild && this.ManageShiftsChild.getAllShifts().length > 0) {
            // Store the pending changes and show confirmation dialog
            this.setState({ 
                showShiftResetConfirmation: true, 
                pendingShiftReset: true,
                pendingChanges: change // Store the pending changes
            });
            return;
        }

        // If no confirmation needed, just update the state
        this.setState(change, () => {
            // If department changed and we have all required fields, reload ShiftCreation
            if (shouldReloadShifts &&
                this.state.divisionLocationId &&
                this.state.departmentId &&
                this.state.reqPosition.jobPosition?.id) {

                // Reset and reload shifts in ShiftCreation component
                if (this.ManageShiftsChild && typeof this.ManageShiftsChild.reloadDefaultShifts === 'function') {
                    this.ManageShiftsChild.reloadDefaultShifts();
                }
            }
        });
    };

    handlePositionChange = (e) => {
        let { name, value, type } = e.target;
        const { reqPosition } = this.state;
        if (type == "radio") {
            reqPosition[name] = value == "true" ? true : false;
        } else {
            reqPosition[name] = type === "checkbox" ? e.target.checked : value;
        }
        this.setState({ reqPosition: reqPosition, isDirty: true });
    };

    handleReqApproversChange = (data) => {
        this.setState({ reqApproverDetails: data });
    };

    handleTimesheetApproversChange = (data) => {
        this.setState({ timesheetApproverDetails: data });
    };

    saveRequisition(isSubmit: boolean) {
        if (this.checkValidations(isSubmit)) {
            this.setState({ isDirty: false });
            let data = JSON.parse(JSON.stringify(this.state));
            data.reqPosition.startDate = toLocalDateTime(data.reqPosition.startDate);
            data.reqPosition.endDate = toLocalDateTime(data.reqPosition.endDate);
            data.reqPosition.shiftStartTime = toLocalDateTime(data.reqPosition.shiftStartTime);
            data.reqPosition.shiftEndTime = toLocalDateTime(data.reqPosition.shiftEndTime);
            data["isSubmit"] = isSubmit;
            data.clientContactNum = data.clientContactNum ? data.clientContactNum.replace(/\D+/g, "") : "";

            // Get shifts from the ShiftCreation component
            if (this.ManageShiftsChild && typeof this.ManageShiftsChild.getAllShifts === 'function') {
                data.reqShifts = this.ManageShiftsChild.getAllShifts();
                //console.log('Shifts to be saved:', data.reqShifts);
            } else {
                data.reqShifts = [];
                //console.log('No shifts to save or ShiftCreation component not available');
            }

            const successMsg = isSubmit ? SUBMIT_ORDER_SUCCESS_MSG : SAVED_ORDER_SUCCESS_MSG;
            let httpVerb = data.reqId ? "put" : "post";
            axios[httpVerb]("/api/requisitions", JSON.stringify(data)).then((res) => {
                successToastr(successMsg);
                if (auth.hasPermissionV2(AppPermissions.REQ_VIEW)) {
                    history.push("/requisitions/manage");
                } else {
                    history.push(APP_HOME_URL);
                }
            });
        }
    }

    checkValidations(isSubmit) {
        if (this.state.reqApproverDetails.hasOwnProperty("wfApprovalLevel")) {
            let hasUnsavedChanges = this.state.reqApproverDetails.wfApprovalLevel.some((x) => x.inEdit == true);
            if (hasUnsavedChanges) {
                warningToastr(REQ_APPROVERS_WARNING_MSG);
                return false;
            }
        }
        if (this.state.timesheetApproverDetails.hasOwnProperty("wfApprovalLevel")) {
            let hasUnsavedChanges = this.state.timesheetApproverDetails.wfApprovalLevel.some((x) => x.inEdit == true);
            if (hasUnsavedChanges) {
                warningToastr(TS_APPROVERS_WARNING_MSG);
                return false;
            }
            let hasAtleasetOneLevel = this.state.timesheetApproverDetails.wfApprovalLevel.length > 0;
            if (!hasAtleasetOneLevel && (isSubmit || this.state.status != ReqStatus.DRAFT)) {
                warningToastr(TS_APPROVERS_REQUIRED_WARNING_MSG);
                return false;
            }
        }
        return true;
    }

    getReqDetails(reqId: string) {
        axios.get(`api/requisitions/${reqId}`).then((res: any) => {
            const { data } = res;
            this.setState({
                reqId: data.reqId,
                reqNumber: data.reqNumber,
                // clientId: data.client.id,
                clientDivisionId: data.clientDivision.id,
                divisionLocationId: data.divisionLocation.id,
                divLocId: data.divisionLocation.id,
                purchaseOrder: data.purchaseOrder,
                clientContactNum: FormatPhoneNumber(data.clientContactNum),
                divisionContactId: data.divisionContactId,
                reasonId: (data.reason && data.reason.id) || null,
                customerLocation: data.customerLocation,
                justification: data.justification,
                additionalDetails: data.additionalDetails,
                status: data.status,
                departmentId: data.departmentId,
                isPilot: data.isPilot,
                showTargetRate: data.showTargetRate,
                atsReqNumber: data.atsReqNumber,
                salesforceContractNumber: data.salesforceContractNumber,
                entityNumber:data.entityNumber,
            }, () => this.getServiceCategories());
            this.reqChild.getLocations(data.clientDivisionId);
            this.reqChild.getDepartments(this.state.divisionLocationId);
            if (data.clientDivision.city || data.clientDivision.state) {
                this.reqChild.updateLocationInfo(data.clientDivision);
            } else {
                this.reqChild.updateLocationInfo(data.divisionLocation);
            }

        });
    }

    hasUsavedData() {
        if (!this.state.isDirty) {
            window.onbeforeunload = null;
        } else {
            return "";
        }
    }

    onCollapseOpen = () => {
        this.setState({
            toggleAll: true,
            toggelFirst: true,
            toggleFourth: true,
            toggleFifth: true,
            toggleThird: true,
            toggleSecond: true,
        });
    };

    onCollapseClose = () => {
        this.setState({
            toggleAll: false,
            toggelFirst: false,
            toggleFourth: false,
            toggleFifth: false,
            toggleThird: false,
            toggleSecond: false,
        });
    };

    getClientSetting = (id) => {
        this.setState({ showLoader: true })
        getClientSettingsData(id).then((res) => {

            applySettingFilters(res, SettingCategory.CANDIDATE, SETTINGS.RATE_LOCKDOWN, (response) => {
                this.setState({ isRateLockdown: response });
            });

            applySettingFilters(res, SettingCategory.REQUISITION, SETTINGS.DISPLAY_CLIENT_ATS_REQ, (response) => {
                this.setState({ displayClientAtsReq: response });
            });

            applySettingFilters(res, SettingCategory.SCHEDULING, SETTINGS.SHIFT_SCHEDULING, (response) => {
                this.setState({ shiftScheduling: response });
            });

            applySettingFilters(res, SettingCategory.REQUISITION, SETTINGS.DISPLAY_SALESFORCE_CONTRACT_NUMBER, (response) => {
                this.setState({ displaySalesforceContractNumber: response });
            });
            applySettingFilters(res, SettingCategory.REQUISITION, SETTINGS.DISPLAY_ENTITY_NUMBER, (response) => {
                this.setState({ displayEntityNumber: response });
            });
        });
    };

    handleCheckboxChange = (e, modelProp) => {
        var stateObj = {};
        stateObj[modelProp] = e.target.type == "checkbox" ? e.target.checked : e.target.value;
        this.setState(stateObj);
        if (modelProp == "showTargetRate") {
            this.handleBudget(this.state.divisionLocationId)
        }
    }

    getServiceCategories = () => {
        axios.get(`api/candidates/servicecat?$filter=name eq 'Time'`).then((res) => {
            this.setState({ serviceCategoryId: res.data[0].id }, () => {
                if (this.state.reqId) {
                    this.handleBudget(this.state.divisionLocationId);
                }
            });
        });
    }

    handleBudget = (divisionLocationId) => {
        const { clientId, serviceCategoryId, clientDivisionId, reqPosition } = this.state;
        if (clientDivisionId != null && clientDivisionId != "" && divisionLocationId != null && divisionLocationId != "" && reqPosition.jobPosition.id != null && reqPosition.jobPosition.id != "") {
            this.positionChild.getServiceTypes(serviceCategoryId, clientId, clientDivisionId, divisionLocationId, reqPosition.jobPosition.id);
        }
    }

    handleShiftResetConfirmation = (confirmed: boolean) => {
        this.setState({ showShiftResetConfirmation: false });
        
        if (confirmed && this.state.pendingShiftReset && this.state.pendingChanges) {
            // Apply the pending changes
            this.setState(this.state.pendingChanges, () => {
                if (this.ManageShiftsChild && typeof this.ManageShiftsChild.reloadDefaultShifts === 'function') {
                    this.ManageShiftsChild.reloadDefaultShifts();
                }
                // Get approvers after state update
                this.getApprovers(this.state.pendingChanges, EntityType.REQUISITION);
                this.getApprovers(this.state.pendingChanges, EntityType.TIMESHEET);
            });
        }
        
        // Clear the pending state
        this.setState({ 
            pendingShiftReset: false,
            pendingChanges: null 
        });
    };

    handleSalesforceContractNumber = (salesforceContractNumber) => {
        if(this.state.displaySalesforceContractNumber){
            if(salesforceContractNumber!== null && salesforceContractNumber != ""){
                this.setState({ salesforceContractNumber: salesforceContractNumber });
            }
            else{
                this.setState({ salesforceContractNumber: "" });
            }
        }
    }
    handleEntityNumber = (entityNumber) => {
        if (this.state.displayEntityNumber) {
            if (entityNumber !== null && entityNumber != "") {
                this.setState({ entityNumber: entityNumber });
            }
            else {
                this.setState({ entityNumber: "" });
            }
        }
    }
    render() {
        const {
            reqId,
            clientId,
            clientDivisionId,
            divisionLocationId,
            divLocId,
            purchaseOrder,
            clientContactNum,
            divisionContactId,
            reasonId,
            customerLocation,
            justification,
            status,
            reqPosition,
            toggleAll,
            toggelFirst,
            toggleSecond,
            toggleThird,
            toggleFourth,
            toggleFifth,
            allowEdit,
            additionalDetails,
            departmentId,
            isRateLockdown,
            isPilot,
            serviceCategoryId,
            showTargetRate,
            displayClientAtsReq,
            shiftScheduling,
            atsReqNumber,
            salesforceContractNumber,
            displaySalesforceContractNumber,
            displayEntityNumber,
            entityNumber
        } = this.state;
        const reqDetails = {
            reqId,
            clientId,
            clientDivisionId,
            divisionLocationId,
            divLocId,
            purchaseOrder,
            clientContactNum,
            divisionContactId,
            reasonId,
            customerLocation,
            justification,
            additionalDetails,
            departmentId,
            status,
            isRateLockdown,
            isPilot,
            showTargetRate,
            displayClientAtsReq,
            atsReqNumber,
            salesforceContractNumber,
            displaySalesforceContractNumber,
            entityNumber,
            displayEntityNumber
        };
        reqPosition.reqId = reqId;
        reqPosition.clientDivisionId = clientDivisionId;
        reqPosition.divisionLocationId = divisionLocationId;
        reqPosition.serviceCategoryId = serviceCategoryId;
        reqPosition.showTargetRate = showTargetRate;
        const reqTriggerName = (
            <span>
                Requisition Details
                <span
                    className="d-none d-sm-block"
                    style={{ float: "right", marginRight: "25px" }}
                >
                    Status : <span className="font-weight-bold">{status}</span>
                </span>
            </span>
        );
        return (
            <div className="col-11 mx-auto pl-0 pr-0 mt-3" key={this.props.location.key}>
                <Prompt
                    when={this.state.isDirty}
                    message={(location) => `Changes you made may not be saved.`}
                />
                <div className="col-12 p-0 shadow pt-1 pb-1">
                    <div className="col-12 ml-0 mr-0">
                        <div className="row pt-2 pb-2 accordianTitleClr mx-auto mb-3 mt-3">
                            <div className="col-2 col-md-4 fonFifteen paddingLeftandRight">
                                <div className="d-none d-md-block">
                                    <BreadCrumbs globalData={{ clientId: this.state.clientId, requisitionId: this.state.reqId }}></BreadCrumbs>
                                </div>
                            </div>
                            <div className="col-10 col-md-8 text-right mt-sm-1 mt-md-0 txt-orderno text-underline paddingRight d-flex align-items-center justify-content-end">
                                Req# : {this.state.reqNumber ? this.state.reqNumber : "NA"}
                                {(toggleFourth && toggleSecond && toggelFirst && toggleThird) ||
                                    toggleAll ? (
                                    <FontAwesomeIcon
                                        className="ml-2 mt-1 text-primary collapseExpandIcon globalExpandCursor"
                                        icon={faChevronCircleUp}
                                        onClick={
                                            toggleAll ? this.onCollapseClose : this.onCollapseOpen
                                        }
                                    ></FontAwesomeIcon>
                                ) : (
                                    <FontAwesomeIcon
                                        className="ml-2 mt-1 text-primary collapseExpandIcon globalExpandCursor"
                                        icon={faChevronCircleDown}
                                        onClick={
                                            toggleAll ? this.onCollapseClose : this.onCollapseOpen
                                        }
                                    ></FontAwesomeIcon>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-11 pr-0">
                            <div className="d-block d-md-none text-right">
                                Status : <span className="font-weight-bold"> {status} </span>
                            </div>
                        </div>
                    </div>

                    <Formik
                        validateOnMount={this.state.submitted}
                        initialValues={this.state}
                        validateOnChange={false}
                        enableReinitialize={true}
                        validationSchema={requisitionValidation}
                        validateOnBlur={false}
                        onSubmit={(fields) => this.saveRequisition(ReqStatus.DRAFT == this.state.status ? true : false)}
                        render={(formikProps) => (
                            <Form noValidate className="col-12 ml-0 mr-0" id="collapsiblePadding" translate="yes" onChange={formikProps.handleChange}>
                                <Collapsible
                                    trigger={reqTriggerName}
                                    open={toggelFirst}
                                    accordionPosition="1"
                                    onTriggerOpening={() => this.setState({ toggelFirst: true })}
                                    onTriggerClosing={() => this.setState({ toggelFirst: false })}
                                >
                                    {((reqId && clientDivisionId) || !reqId) &&
                                    <RequisitionDetails
                                        ref={(instance) => {
                                            this.reqChild = instance;
                                        }}
                                        data={reqDetails}
                                        clientId={clientId}
                                        handleChange={this.handleChange}
                                        handleObjChange={this.handleObjChange}
                                        handleDropdownChange={this.handleDropdownChange}
                                        formikProps={formikProps}
                                        disableDivAndLoc={this.state.status == ReqStatus.APPROVED}
                                        handleChangePurchaseOrder={this.handleChangePurchaseOrder}
                                        handleCheckboxChange={this.handleCheckboxChange}
                                        handleBudget={this.handleBudget}
                                        handleSalesforceContractNumber={this.handleSalesforceContractNumber}
                                        handleEntityNumber={this.handleEntityNumber }
                                    />}
                                </Collapsible>

                                <div>
                                    <Collapsible
                                        lazyRender={reqId ? false : true}
                                        trigger="Position Details"
                                        open={toggleSecond}
                                        onTriggerOpening={() => this.setState({ toggleSecond: true })}
                                        onTriggerClosing={() => this.setState({ toggleSecond: false })}
                                    >
                                        <PositionDetails
                                            ref={(instance) => {
                                                this.positionChild = instance;
                                            }}
                                            data={reqPosition}
                                            clientId={clientId}
                                            handlePositionChange={this.handlePositionChange}
                                            handleObjChange={this.handleObjChange}
                                            formikProps={formikProps}
                                        />
                                    </Collapsible>

                                    {/* starting Shift */}
                                    {shiftScheduling == true && (
                                        <Collapsible
                                            lazyRender={reqId ? false : true}
                                            trigger="Shifts"
                                            open={toggleFifth}
                                            onTriggerOpening={() => this.setState({ toggleFifth: true })}
                                            onTriggerClosing={() => this.setState({ toggleFifth: false })}
                                        >
                                            <ManageShifts
                                                ref={(instance) => {
                                                    this.ManageShiftsChild = instance;
                                                }}
                                                reqId={this.state.reqId}
                                                targetStartDate={this.state.reqPosition.startDate}
                                                targetEndDate={this.state.reqPosition.endDate}
                                                positionName={this.state.reqPosition.jobPosition ? this.state.reqPosition.jobPosition.name : ''}
                                                positionId={this.state.reqPosition.jobPosition ? this.state.reqPosition.jobPosition.id : ''}
                                                capacity={this.state.reqPosition.noOfReqStaff}
                                                locationId={this.state.divisionLocationId}
                                                locationName={this.state.divisionLocationId ? this.reqChild && this.reqChild.state && this.reqChild.state.locations.find(loc => loc.id === this.state.divisionLocationId)?.name : ''}
                                                departmentId={this.state.departmentId}
                                                departmentName={this.state.departmentId ? this.reqChild && this.reqChild.state && this.reqChild.state.departments.find(dept => dept.id === this.state.departmentId)?.name : ''}
                                            />

                                        </Collapsible>
                                    )}

                                    <Collapsible
                                        lazyRender={false}
                                        trigger="Requisition Approvers"
                                        open={toggleThird}
                                        onTriggerOpening={() => this.setState({ toggleThird: true })}
                                        onTriggerClosing={() => this.setState({ toggleThird: false })}
                                        key={"Requisition"}
                                    >
                                        {this.state.status &&
                                            <ApprovalsWFGrid
                                                ref={(instance) => {
                                                    this.reqApprovalChild = instance;
                                                }}
                                                entityId={reqId}
                                                entityType="Requisition"
                                                clientId={clientId}
                                                permission={AppPermissions.REQ_APPROVE}
                                                canEdit={true}
                                                canEditDefault={allowEdit}
                                                disableAddLevel={this.state.status == ReqStatus.APPROVED}
                                                disableActiveLevel={this.state.status != ReqStatus.DRAFT}
                                                key="Requisition"
                                                handleApproversChange={this.handleReqApproversChange}
                                            />}
                                    </Collapsible>
                                    <Collapsible
                                        lazyRender={false}
                                        trigger="Timesheet Approvers"
                                        open={toggleFourth}
                                        onTriggerOpening={() => this.setState({ toggleFourth: true })}
                                        onTriggerClosing={() => this.setState({ toggleFourth: false })}
                                    >
                                        {this.state.status &&
                                            <ApprovalsWFGrid
                                                ref={(instance) => {
                                                    this.tsApprovalChild = instance;
                                                }}
                                                entityId={reqId}
                                                entityType="Timesheet"
                                                clientId={clientId}
                                                permission={AppPermissions.TS_APPROVE}
                                                canEdit={true}
                                                canEditDefault={allowEdit}
                                                key="Timesheet"
                                                handleApproversChange={this.handleTimesheetApproversChange}
                                            />}
                                    </Collapsible>
                                </div>

                                <div className="row mb-2 mb-lg-4  ml-sm-0 mr-sm-0">
                                    <div className="col-12 mt-5 text-sm-center text-center font-regular">
                                        <button type="button" onClick={() => history.goBack()} className="btn button button-close mr-2 shadow mb-2 mb-xl-0">
                                            <FontAwesomeIcon icon={faTimesCircle} className={"mr-1"} />
                                            Close
                                        </button>
                                        {this.state.status == ReqStatus.DRAFT && auth.hasPermissionV2(AppPermissions.REQ_CREATE) && (
                                            <button
                                                type="button"
                                                disabled={!clientId}
                                                className="btn button button-bg mr-2 mb-2 shadow  mb-xl-0"
                                                onClick={() => {
                                                    let isValid = true;
                                                    if (!this.state.clientDivisionId) {
                                                        formikProps.setFieldError('clientDivisionId', 'This field is required');
                                                        isValid = false;
                                                    }
                                                    if (!this.state.divisionLocationId) {
                                                        formikProps.setFieldError('divisionLocationId', 'This field is required');
                                                        isValid = false;
                                                    }
                                                    if (this.state.reqPosition.noOfReqStaff > 999) {
                                                        formikProps.setFieldError('reqPosition.noOfReqStaff', 'No of required staff cannot be greater than 999');
                                                        isValid = false;
                                                    }
                                                    if (this.state.reqPosition.noOfReqStaff < 1) {
                                                        formikProps.setFieldError('reqPosition.noOfReqStaff', 'No of required staff cannot be less than 1');
                                                        isValid = false;
                                                    }
                                                    if (this.state.reqPosition.endDate == null) {
                                                        formikProps.setFieldError('reqPosition.endDate', 'This field is required');
                                                        isValid = false;
                                                    }
                                                    if (isValid) {
                                                        this.saveRequisition(false);
                                                    }
                                                }}
                                            >
                                                <FontAwesomeIcon icon={faSave} className={"mr-1"} /> Save
                                            </button>
                                        )}
                                        {this.state.status == ReqStatus.DRAFT && auth.hasPermissionV2(AppPermissions.REQ_CREATE) && (
                                            <button
                                                type="submit"
                                                disabled={!clientId}
                                                className="btn button button-bg shadow mb-2 mb-xl-0"
                                                onClick={() => {
                                                    if (formikProps.errors) {
                                                        this.setState({
                                                            toggelFirst: true,
                                                            toggleSecond: true,
                                                        });
                                                    }
                                                    this.setState({ submitted: true, errorValidate: true }, () =>
                                                        setTimeout(() => this.setState({ errorValidate: false }), 50)
                                                    );
                                                }}
                                            >
                                                <FontAwesomeIcon icon={faCheckCircle} className={"mr-1"} /> Submit
                                            </button>
                                        )}
                                        {this.state.status != ReqStatus.DRAFT && auth.hasPermissionV2(AppPermissions.REQ_UPDATE) && (
                                            <button
                                                type="submit"
                                                disabled={!clientId}
                                                className="btn button button-bg shadow mb-2 mb-xl-0"
                                                onClick={() => {
                                                    if (formikProps.errors) {
                                                        this.setState({
                                                            toggelFirst: true,
                                                            toggleSecond: true,
                                                        });
                                                    }
                                                    this.setState({ submitted: true, errorValidate: true }, () =>
                                                        setTimeout(() => this.setState({ errorValidate: false }), 50)
                                                    );
                                                }}
                                            >
                                                <FontAwesomeIcon icon={faCheckCircle} className={"mr-1"} /> Update
                                            </button>
                                        )}
                                    </div>
                                </div>

                                {this.state.errorValidate ? <ErrorFocus /> : null}
                            </Form>
                        )}
                    />
                </div>
                <ConfirmationModal
                    showModal={this.state.showShiftResetConfirmation}
                    message={REQ_SHIFT_RESET_CONFIRM_MSG}
                    handleYes={() => this.handleShiftResetConfirmation(true)}
                    handleNo={() => this.handleShiftResetConfirmation(false)}
                />
            </div>
        );
    }
}

export default CreateRequisition;
